import React from 'react';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
import { ReturnMethodErrorType } from '@src/constants/general';

interface WholeOrderMethodErrorProps {
  showError: boolean;
  type?: ReturnMethodErrorType;
}

const WholeOrderMethodError = React.forwardRef<
  HTMLDivElement,
  WholeOrderMethodErrorProps
>((props, ref) => {
  const { type, showError } = props;

  const weightLimitErrorMessage = (
    <>
      Total weight cannot exceed 150 pounds for UPS Drop-Off. Please call
      866-333-3551 for assistance.
    </>
  );
  const messageMapper = {
    [ReturnMethodErrorType.WEIGHT_LIMIT_EXCEEDED]: weightLimitErrorMessage,
  };

  return (
    <div ref={ref}>
      {showError && (
        <div className="sui-mb-8" data-testid="whole-order-method-error">
          <Alert status="error" size="large">
            <Typography variant="body-base">
              {type && messageMapper[type as keyof typeof messageMapper]
                ? messageMapper[type as keyof typeof messageMapper]
                : 'Please select a return method.'}
            </Typography>
          </Alert>
        </div>
      )}
    </div>
  );
});

export default WholeOrderMethodError;
